module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp1_0.4b129b45.png";